
export * from '../../frontend-js-dependencies-web/__liferay__/exports/clipboard.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/clipboard.js';
export default __default__;
